// import axios from 'axios';

// // Set your ThingsBoard base URL here
// const API = axios.create({
//   baseURL: 'https://3tp.tapasyatech.in/', // Change to your actual TB host
// });

// // Interceptor to add Token to every request automatically
// API.interceptors.request.use((config) => {
//   const token = localStorage.getItem('token');
//   if (token) {
//     config.headers['X-Authorization'] = `Bearer ${token}`;
//   }
//   return config;
// });

// export const getTelemetryData = async (entityId) => {
//   try {
//     const response = await API.get(`/api/plugins/telemetry/DEVICE/${entityId}/values/timeseries`, {
//       params: { keys: 'data' }
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

// export const loginUser = async (username, password) => {
//   const response = await API.post('/api/auth/login', { username, password });
//   return response.data; // Returns {token, refreshToken}
// };





import axios from "axios";

const api = axios.create({
  baseURL: "https://3tp.tapasyatech.in/api"
});

// Interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// -------- AUTH ----------
export const loginAPI = (username, password) => {
  return api.post("/auth/login", { username, password });
};

// -------- TELEMETRY ----------
export const telemetryAPI = (entityId) => {
  return api.get(
    `/plugins/telemetry/DEVICE/${entityId}/values/timeseries`
  );
};
